import { Injectable } from '@angular/core';
import * as $ from 'jquery';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Environment } from '../../config/environment';
import { Config } from '../../config/config';
import {HttpClientModule} from '@angular/common/http';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InternalCustomerDetailService {


    constructor(private http: HttpClient, private Conf: Config) { 
    }

    public getData(data){

 

      let httpOptions = {
        withCredentials: false,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        })
      };

      if(Environment.CREDENTIALS){
        httpOptions.withCredentials = true;
      }

      let url = this.Conf.ENDPOINT_API + 'getApplicantDetail';
      let request = Object.assign({}, data);

      return this.http.post(url, request, httpOptions);   

    }

    public getCustomerDetailData(data){

      let url = this.Conf.ENDPOINT_API + 'internal/getIntPersonaFilter';
      let request = Object.assign({}, data);
      let headers = new HttpHeaders({
        'Content-Type': 'application/json',
      })
      let wc = (Environment.CREDENTIALS) ? true : false;
      
      return this.http.post(url, request, {headers: headers, observe: "response",withCredentials: wc})
        
    }

 
    public getHistory(data){

 

      let httpOptions = {
        withCredentials: false,
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };

      if(Environment.CREDENTIALS){
        httpOptions.withCredentials = true;
      }

      let url = this.Conf.ENDPOINT_API + 'findByDocNum';
      let request = Object.assign({}, data);

      return this.http.post(url, request, httpOptions);   

    }

}